import React, { useState } from 'react';

const TableRenderer = ({ field, value, onChange, error, readOnly }) => {
  const [rows, setRows] = useState(value || []);

  const addRow = () => {
    const newRow = {};
    field.columns.forEach(col => {
      newRow[col.field_id] = '';
    });
    const newRows = [...rows, newRow];
    setRows(newRows);
    onChange(newRows);
  };

  const removeRow = (index) => {
    const newRows = rows.filter((_, i) => i !== index);
    setRows(newRows);
    onChange(newRows);
  };

  const updateCell = (rowIndex, columnId, cellValue) => {
    const newRows = [...rows];
    newRows[rowIndex][columnId] = cellValue;
    setRows(newRows);
    onChange(newRows);
  };

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {field.label}
        {field.required && <span className="text-red-500 ml-1">*</span>}
      </label>
      {field.help_text && (
        <p className="text-xs text-gray-500 mb-2">{field.help_text}</p>
      )}
      
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300">
          <thead className="bg-gray-50">
            <tr>
              {field.columns && field.columns.map((col, index) => (
                <th key={index} className="px-4 py-2 border-b border-gray-300 text-left text-sm font-medium text-gray-700">
                  {col.label}
                  {col.required && <span className="text-red-500 ml-1">*</span>}
                </th>
              ))}
              {!readOnly && <th className="px-4 py-2 border-b border-gray-300 w-20"></th>}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {field.columns && field.columns.map((col, colIndex) => (
                  <td key={colIndex} className="px-4 py-2 border-b border-gray-300">
                    <input
                      type={col.type || 'text'}
                      value={row[col.field_id] || ''}
                      onChange={(e) => updateCell(rowIndex, col.field_id, e.target.value)}
                      disabled={readOnly}
                      className="w-full px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                    />
                  </td>
                ))}
                {!readOnly && (
                  <td className="px-4 py-2 border-b border-gray-300 text-center">
                    <button
                      type="button"
                      onClick={() => removeRow(rowIndex)}
                      className="text-red-600 hover:text-red-800 text-sm"
                    >
                      Remove
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {!readOnly && (
        <button
          type="button"
          onClick={addRow}
          className="mt-2 px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 text-sm"
        >
          Add Row
        </button>
      )}
      
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  );
};

export default TableRenderer;
